import PropTypes from 'prop-types';
import React from 'react';
import FollowUpQuestionField from './follow-up-question-field';

const FollowUpQuestions = ({ questions, answers, onAnswerChange }) => (
  <>
    {questions.map((question, index) => (
      <FollowUpQuestionField
        key={question.text}
        index={index}
        question={question.text}
        mandatory={question.mandatory}
        value={answers[index]}
        onChange={onAnswerChange}
      />
    ))}
  </>
);

FollowUpQuestions.propTypes = {
  questions: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    mandatory: PropTypes.bool,
  })).isRequired,
  answers: PropTypes.arrayOf(PropTypes.string).isRequired,
  onAnswerChange: PropTypes.func.isRequired,
};

export default FollowUpQuestions;
